import { API_URLS } from "constants/apiConstants";
import { OfflineDays, ServiceAvailabilityException } from "../types/entities";
import { ApiClient, ApiResponse } from "./requestExecutor";

export class DatesApi extends ApiClient {
	//This function fetches the fully disabled days 
	public fetchDaysOffline = async (): Promise<ApiResponse<OfflineDays[]>> => {
		try {
			return this.get<OfflineDays[]>(API_URLS.days.daysOfflineUrl);
		} catch (error) {
			console.error("Error al obtener los días offline:", error);
			throw error;
		}
	};

	//This function fetches the fully disabled days of the services (ServiceException)
	public fetchServicesDaysOffline = async (): Promise<
		ApiResponse<ServiceAvailabilityException[]>
	> => {
		try {
			return this.get<ServiceAvailabilityException[]>(
				API_URLS.days.servicesDaysOfflineUrl
			);
		} catch (error) {
			console.error("Error al obtener los días offline de los servicios:", error);
			throw error;
		}
	};

	//This function fetches the dates that have all the service's shifts disabled
	public fetchDaysOfflineByService = async (id: string): Promise<
		ApiResponse<OfflineDays[]>
	> => {
		try {
			return this.get<OfflineDays[]>(
				`${API_URLS.days.daysOfflineByServiceUrl}/${id}`
			);
		} catch (error) {
			console.error("Error al obtener los días offline del servicio:", error);
			throw error;
		}
	};
}
